import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import Button from '../../formElements/Button';

import AuditAppointmentManagement from './AuditAppointmentManagement';

import modal from '../../../commonStyles/modal.module.css';

const AuditAppointmentModal = ({ label, modalHeadingLabel, isOpen, onClose, participantId }) => {
    // RENDER
    return (
        <Dialog
            onClose={onClose}
            open={isOpen}
            onClick={(e) => e.stopPropagation()}
            className="muiDialogWrapper"
            id="auditModal">
            <div className={modal.modalHeader}>
                <DialogTitle>{modalHeadingLabel || label} Change History</DialogTitle>
            </div>
            <DialogContent>
                <>
                    <div className={modal.mainContent}>
                        <AuditAppointmentManagement participantId={participantId} />
                    </div>
                    <div className={modal.actionButtons}>
                        <div className={modal.cancelButton}>
                            <Button id="auditModalButton" onClick={onClose} content="Close" />
                        </div>
                    </div>
                </>
            </DialogContent>
        </Dialog>
    );
};

AuditAppointmentModal.propTypes = {
    label: PropTypes.string,
    modalHeadingLabel: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    participantId: PropTypes.string
};

export default AuditAppointmentModal;
